const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/teams/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { requirePermission } from '@/common/hooks/usePermissions';
import i18n from '@/common/translations/i18n';
import { ensureNamespaceLoaded } from '@/common/translations/i18nloader';
import { periodSearchSchema } from './-utils/searchParams';
const teamsSearchSchema = z.object(periodSearchSchema);
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/teams')({
  validateSearch: zodValidator(teamsSearchSchema),
  beforeLoad: async ctx => {
    await requirePermission('edit_capacity')(ctx);
    await ensureNamespaceLoaded('teams');
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    topNav: {
      title: i18n.t($ => $.loops.teams)
    }
  }
});